(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("ELEMENT"), require("_"), require("Vue"), require("moment"), require("$"), require("axios"));
	else if(typeof define === 'function' && define.amd)
		define(["ELEMENT", "_", "Vue", "moment", "$", "axios"], factory);
	else if(typeof exports === 'object')
		exports["legacy-resource"] = factory(require("ELEMENT"), require("_"), require("Vue"), require("moment"), require("$"), require("axios"));
	else
		root["legacy-resource"] = factory(root["ELEMENT"], root["_"], root["Vue"], root["moment"], root["$"], root["axios"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__5f72__, __WEBPACK_EXTERNAL_MODULE__60bb__, __WEBPACK_EXTERNAL_MODULE__8bbf__, __WEBPACK_EXTERNAL_MODULE_c32d__, __WEBPACK_EXTERNAL_MODULE_c5e1__, __WEBPACK_EXTERNAL_MODULE_cebe__) {
return 